<template>
  <div
    class="app"
    :class="`current-scene-${currentScene}`"
  >
    <div class="stage">
      <div class="stage__padding">
        <div class="stage__inner">
          <button
            class="scene__nav scene__nav--previous button"
            v-if="currentScene > 1"
            @click="navigate('previous')"
          >
            <span class="scene__nav-inner">Back</span>
          </button>
          <button
            class="scene__nav scene__nav--next button"
            @click="navigate('next')"
            v-if="!beginButton"
          >
            <span class="scene__nav-inner">{{ nextButtonText }}</span>
          </button>
          <button
            class="mute"
            :class="{
              'muted': muted
            }"
            @click="toggleMute()"
          >toggle mute</button>
          <button
            class="scene__begin button"
            @click="beginClicked()"
            v-if="beginButton"
          >Begin</button>
          <div
            class="scene scene-1"
            :class="{
              'active': currentScene === 1,
              'active-play': currentScene === 1 && !beginButton,
              'leroy-excited': currentScene === 1 && trackTime >= 20,
              'leroy-running': currentScene === 1 && trackTime >= 21.5
            }"
          >
            <div class="scene-1__tree"></div>
            <PearlieSue
              :speak-duration="23000"
              ref="pearlieSueScene1"
            ></PearlieSue>
            <Leroy></Leroy>
            <h1 class="scene-1__title">Praise House</h1>
            <p
              class="scene-1__text"
              :class="{
                'active': trackTime < 12
              }"
            >
              Welcome to our praise house. This is the focal point for Africans on the plantation. It is the one place we could get a little freedom to enjoy ourselves without the overseer and master looking over our shoulder.
            </p>
            <p
              class="scene-1__text"
              :class="{
                'active': trackTime >= 12
              }"
            >
              I tell ya, it served as the center for worship and community leadership. Now y'all come on and follow me and Rev. Leroy to the praise house for a shoutin' good time.
            </p>
            <div class="scene-1__praise-the-lord"></div>
          </div>
          <div
            class="scene scene-2"
            :class="{
              'active': currentScene === 2,
              'play-drums': currentScene === 2 && (trackTime >= 6.5 && trackTime <= 21)
            }"
          >
            <h2 class="scene-2__title">African Drums</h2>
            <div class="scene-2__text"><p>Now back in Africa everywhere you go we used the drum for communication. It was the main instrument for anything we did. We know what the drum was saying but the master didn't know. He thought we could talk about leaving or escaping. So he didn't let us bring the drums over here.</p></div>
            <div class="scene-2__africa-map"></div>
            <div class="scene-2__africa-label"></div>
            <PearlieSue
              :speak-duration="16000"
              ref="pearlieSueScene2"
            ></PearlieSue>
            <Drummer></Drummer>
          </div>
          <div
            class="scene scene-3"
            :class="{
              'active': currentScene === 3,
              'leroy-jumping': currentScene === 3 && (trackTime >= 13 && trackTime <= 29)
            }"
          >
            <h2 class="scene-3__title">Walking Stick</h2>
            <div class="scene-3__text">
              <p>Another way to keep the rhythm of the shout was the use of a walking stick on the wooden floor of the praise house. Oh, yes sir! When you hear that beat and that wood meet the wood you can hear the heartbeat of Africa.</p>
              <p>Now see Reverend Leroy over there? Reverend Leroy sure knows how to keep the beat going. Oh Rev. come on and show 'em what you know, show 'em Rev. Show 'em how to keep that beat of Africa going.</p>
            </div>
            <Leroy></Leroy>
          </div>
          <div
            class="scene scene-4"
            :class="{
              'active': currentScene === 4,
              'feet-stomping': currentScene === 4 && trackTime <= 16,
              'hands-clapping': currentScene === 4 && trackTime <= 16
            }"
          >
            <h2 class="scene-4__title">Human Body</h2>
            <div class="scene-4__text">
              <p>During a meeting in the Praise House we use our hands, we use our bodies, we sing the song, we stomp our feet, whatever it takes to keep that rhythm because the rhythm is the most important part of African American music.</p>
            </div>
            <PearlieSue
              :speak-duration="16000"
              ref="pearlieSueScene4"
            ></PearlieSue>
            <Hands></Hands>
            <Feet></Feet>
          </div>
          <div
            class="scene scene-5"
            :class="{
              'active': currentScene === 5,
              'shaking-shakers': currentScene === 5 && (trackTime >= 10 && trackTime <= 20)
            }"
          >
            <h2 class="scene-5__title">Gourd Shakers</h2>
            <div class="scene-5__text">
              <p>The Africans were accustomed to taking just whatever they had in their immediate environment and making good use of it, so when the master took the drum, we found gourds.</p>
              <p>The gourds grew down here in the south just like they grew back home and after they dry out, the seeds inside give it a shakin' sound. Oh, yes sir!</p>
            </div>
            <div class="scene-5__gourds"></div>
            <PearlieSue
              :speak-duration="18000"
              :shakers="true"
              ref="pearlieSueScene5"
            ></PearlieSue>
          </div>
          <div
            class="scene scene-6"
            :class="{
              'active': currentScene === 6
            }"
          >
            <h2 class="scene-6__title">Ring Shout</h2>
            <div class="scene-6__text">
              <p>Now the ring shout was straight from Africa. The only thing Africans could do without permission on the plantation was to sing. Oh, yes sir. We sing down the cotton field, up and down them cotton rows.</p>
              <p>If you wasn't a member of the praise house, you could not be up in no ring shout, and as long as you shuffle your foot from side to side you were doing it right, but when you cross your ankle that be the devil dance. You ain't doing the ring shout then.</p>
            </div>
            <PearlieSue
              :speak-duration="30000"
              :full-body="true"
              ref="pearlieSueScene6"
            ></PearlieSue>
          </div>
          <div
            class="scene scene-7"
            :class="{
              'active': currentScene === 7,
              'help-window-active': isHelpWindowActive,
              'shaking': isShakerPlaying,
              'leroy-jumping': isWalkingStickPlaying,
              'hands-clapping': isHandClapPlaying,
              'feet-stomping': isFootStompPlaying
            }"
          >
            <div class="scene-7__title-background"></div>
            <h2 class="scene-7__title">Praise House Mix</h2>
            <p class="scene-7__instructions">Click on an instrument to start playing.</p>
            <div
              class="scene-7__help-button btn"
              @mouseover="isHelpWindowActive = true"
              @mouseout="isHelpWindowActive = false"
            ></div>
            <div class="scene-7__help-window">
              <div
                class="scene-7__help-close"
                @click="isHelpWindowActive = false"
              ></div>
              <h3 class="scene-7__help-title">How to Play</h3>
              <p>You just learned how enslaved Africans created music for their worship experience. Now it's your turn!</p>
              <p>Click on an instrument to start the audio. Click the instrument again to turn it off. You can have as many instruments playing as you want!</p>
            </div>
            <Shaker
              @click.native="shakerClicked()"
            ></Shaker>
            <button
              class="mixer-button mixer-button--shaker"
              @click.native="shakerClicked()"
            >Shaker</button>
            <Mouth
              ref="vocals"
              @click.native="vocalsClicked()"
            ></Mouth>
            <button
              class="mixer-button mixer-button--vocals"
              @click.native="vocalsClicked()"
            >Vocals</button>
            <Leroy
              @click.native="walkingStickClicked()"
            ></Leroy>
            <button
              class="mixer-button mixer-button--walking-stick"
              @click.native="walkingStickClicked()"
            >Walking Stick</button>
            <Hands
              @click.native="handClapClicked()"
            ></Hands>
            <button
              class="mixer-button mixer-button--hand-clap"
              @click.native="handClapClicked()"
            >Hand Clap</button>
            <Feet
              :facing="'right'"
              @click.native="footStompClicked()"
            ></Feet>
            <button
              class="mixer-button mixer-button--foot-stomp"
              @click.native="footStompClicked()"
            >Foot Stomp</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import PearlieSue from '@/components/PearlieSue'
import Leroy from '@/components/Leroy'
import Drummer from '@/components/Drummer'
import Feet from '@/components/Feet'
import Hands from '@/components/Hands'
import Mouth from '@/components/Mouth'
import Shaker from '@/components/Shaker'
export default {
  name: 'app',
  components: {
    PearlieSue,
    Leroy,
    Drummer,
    Feet,
    Hands,
    Mouth,
    Shaker
  },
  data () {
    return {
      isHelpWindowActive: false
    }
  },
  computed: {
    ...mapState([
      'numScenes',
      'currentScene',
      'beginButton',
      'muted',
      'trackTime',
      'isShakerPlaying',
      'isVocalsPlaying',
      'isWalkingStickPlaying',
      'isHandClapPlaying',
      'isFootStompPlaying'
    ]),
    nextButtonText () {
      if (this.currentScene < this.numScenes) {
        return 'Next'
      } else {
        return 'End'
      }
    }
  },
  methods: {
    ...mapMutations([
      'HIDE_BEGIN_BUTTON',
      'RESET_TRACK_INTERVAL',
      'PLAY_SHAKER',
      'STOP_SHAKER',
      'PLAY_VOCALS',
      'STOP_VOCALS',
      'PLAY_WALKING_STICK',
      'STOP_WALKING_STICK',
      'PLAY_HAND_CLAP',
      'STOP_HAND_CLAP',
      'PLAY_FOOT_STOMP',
      'STOP_FOOT_STOMP'
    ]),
    ...mapActions([
      'begin',
      'previousScene',
      'nextScene',
      'toggleMute',
      'stopMixer'
    ]),
    beginClicked () {
      this.begin()
      this.$refs.pearlieSueScene1.speak()
    },
    navigate (direction) {
      this.$refs.vocals.stopSinging()
      this.stopMixer()
      if (direction === 'next') {
        this.nextScene()
      } else {
        this.previousScene()
      }
      if (this.$refs[`pearlieSueScene${this.currentScene}`]) {
        this.$refs[`pearlieSueScene${this.currentScene}`].speak()
      }
    },
    shakerClicked () {
      if (this.isShakerPlaying) {
        this.STOP_SHAKER()
      } else {
        this.PLAY_SHAKER()
      }
    },
    vocalsClicked () {
      if (this.isVocalsPlaying) {
        this.STOP_VOCALS()
        this.$refs.vocals.stopSinging()
      } else {
        this.PLAY_VOCALS()
        this.$refs.vocals.sing()
      }
    },
    walkingStickClicked () {
      if (this.isWalkingStickPlaying) {
        this.STOP_WALKING_STICK()
      } else {
        this.PLAY_WALKING_STICK()
      }
    },
    handClapClicked () {
      if (this.isHandClapPlaying) {
        this.STOP_HAND_CLAP()
      } else {
        this.PLAY_HAND_CLAP()
      }
    },
    footStompClicked () {
      if (this.isFootStompPlaying) {
        this.STOP_FOOT_STOMP()
      } else {
        this.PLAY_FOOT_STOMP()
      }
    }
  }
}
</script>

<style lang="scss">
body {
  background-color: #FFF;
}
</style>
